// // import axiosClient from "./axiosClient";

// // // =====================================
// // // PAYMENT STATS
// // // =====================================
// // export const getPaymentStats =
// //   async () => {

// //     const response =
// //       await axiosClient.get(
// //         "/payments/stats"
// //       );

// //     return response.data;
// //   };

// // // =====================================
// // // PAYMENT UPLOAD
// // // =====================================
// // export const uploadPayments =
// //   async (file) => {

// //     const formData =
// //       new FormData();

// //     formData.append(
// //       "file",
// //       file
// //     );

// //     const response =
// //       await axiosClient.post(

// //         "/payments/upload",

// //         formData,

// //         {
// //           headers: {
// //             "Content-Type":
// //               "multipart/form-data",
// //           },
// //         }
// //       );

// //     return response.data;
// //   };


// //client/src/api/paymentApi.js

// import axiosClient
//   from "./axiosClient";

// // =====================================
// // PAYMENT STATS
// // =====================================
// export const getPaymentStats =
//   async () => {

//     const response =
//       await axiosClient.get(
//         "/payments/stats"
//       );

//     return response.data;
//   };

// // =====================================
// // PAYMENT EXCEL UPLOAD
// // =====================================
// export const uploadPayments =
//   async (file) => {

//     const formData =
//       new FormData();

//     formData.append(
//       "file",
//       file
//     );

//     const response =
//       await axiosClient.post(

//         "/payments/upload",

//         formData,

//         {
//           headers: {
//             "Content-Type":
//               "multipart/form-data",
//           },
//         }
//       );

//     return response.data;
//   };

// // =====================================
// // GET FILTERED INVOICES
// // =====================================
// export const getInvoices =
//   async (params) => {

//     const response =
//       await axiosClient.get(

//         "/payments/invoices",

//         {
//           params,
//         }
//       );

//     return response.data;
//   };

// // =====================================
// // UPDATE INVOICE
// // =====================================
// export const updateInvoice =
//   async (

//     invoiceId,

//     formData
//   ) => {

//     const response =
//       await axiosClient.put(

//         `/payments/invoices/${invoiceId}`,

//         formData
//       );

//     return response.data;
//   };

// //client/src/api/paymentApi.js
// import axiosClient
// from "./axiosClient";

// // =====================================
// // PAYMENT UPLOAD
// // =====================================
// export const uploadPayments =
//   async (file) => {

//     const formData =
//       new FormData();

//     formData.append(
//       "file",
//       file
//     );

//     const response =
//       await axiosClient.post(

//         "/payments/upload",

//         formData,

//         {
//           headers: {
//             "Content-Type":
//               "multipart/form-data",
//           },
//         }
//       );

//     return response.data;
//   };

// // =====================================
// // PAYMENT STATS
// // =====================================
// export const getPaymentStats =
//   async () => {

//     const response =
//       await axiosClient.get(
//         "/payments/stats"
//       );

//     return response.data;
//   };

// // =====================================
// // GET INVOICES
// // =====================================
// export const getInvoices =
//   async () => {

//     const response =
//       await axiosClient.get(
//         "/payments/invoices"
//       );

//     return response.data;
//   };


//client/src/api/paymentApi.js

import axiosClient
from "./axiosClient";

// =====================================
// PAYMENT UPLOAD
// =====================================
export const uploadPayments =
  async (file) => {

    const formData =
      new FormData();

    formData.append(
      "file",
      file
    );

    const response =
      await axiosClient.post(

        "/payments/upload",

        formData,

        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

    return response.data;
  };

// =====================================
// PAYMENT STATS
// =====================================
export const getPaymentStats =
  async () => {

    const response =
      await axiosClient.get(
        "/payments/stats"
      );

    return response.data;
  };

// =====================================
// GET INVOICES
// =====================================
export const getInvoices =
  async (params = {}) => {

    const response =
      await axiosClient.get(

        "/payments/invoices",

        {
          params,
        }
      );

    return response.data;
  };

// =====================================
// UPDATE INVOICE
// =====================================
export const updateInvoice =
  async (

    id,

    payload

  ) => {

    const response =
      await axiosClient.put(

        `/payments/update/${id}`,

        payload
      );

    return response.data;
  };

  // ─────────────────────────────────────
// SEARCH INVOICES
// ─────────────────────────────────────
export const searchInvoices = async (filters = {}) => {

  const params = new URLSearchParams();

  if (filters.invoice_number)
    params.append("invoice_number", filters.invoice_number);

  if (filters.vendor)
    params.append("vendor", filters.vendor);

  if (filters.billing_quarter)
    params.append("billing_quarter", filters.billing_quarter);

  if (filters.payment_status)
    params.append("payment_status", filters.payment_status);

  const response = await fetch(
    `/api/payments/search?${params.toString()}`
  );

  if (!response.ok) throw new Error("Search failed");

  return response.json();
};

// ─────────────────────────────────────
// GET QUARTERS
// ─────────────────────────────────────
export const getQuarters = async () => {

  const response = await fetch("/api/payments/quarters");

  if (!response.ok) throw new Error("Failed to fetch quarters");

  return response.json();
};